<qr-overlay-topbar (close)="close.emit()" [isFullscreen]="true">
  Agregar Movimiento
</qr-overlay-topbar>

<div class="movement">
  <div class="movement__main">
    <div class="movement__panel">
      <div class="movement__item">
        <div class="movement__container">
          <div class="movement__buttons">
            <qr-button [config]="buttonMovement"></qr-button>
            <p>{{ title }}</p>
          </div>
          <div class="movement__close">
            <qr-button
              [config]="buttonClose"
              (click)="close.emit()"
            ></qr-button>
          </div>
        </div>
      </div>
      <!-- FECHA -->
      <div class="movement__item">
        <div class="movement__date">
          <p class="movement__subtitle">Fecha</p>
          <qr-date-picker
            id="incomeDate"
            [config]="datePickerIncomeDate"
            (datepickerChange)="addIncomeDate($event)"
            (blurChange)="inputTouched('incomeDate')"
            [hasError]="hasErrorInput('incomeDate')"
          ></qr-date-picker>
        </div>
      </div>
      <!-- ITEM -->
      <div class="movement__item">
        <div class="movement__family">
          <p class="movement__subtitle">Familia</p>
          <qr-dropdown
            id="family"
            [config]="dropdownFamilies"
            [selected]="movementForm.value.family"
            (change)="selectFamily($event)"
            (blurChange)="inputTouched('family')"
            [hasError]="hasErrorInput('family')"
          ></qr-dropdown>
        </div>
        <div class="movement__subfamily">
          <p class="movement__subtitle">Subfamilia</p>
          <qr-dropdown
            id="subFamily"
            [config]="dropdownSubFamilies"
            [isDisabled]="isSubFamilyEmpty"
            [selected]="this.subFamilySelected"
            (change)="selectSubFamily($event)"
            (blurChange)="inputTouched('subFamily')"
            [hasError]="hasErrorInput('subFamily')"
          ></qr-dropdown>
        </div>
      </div>
      <!-- CONCEPTO -->
      <div class="movement__item">
        <div class="movement__concept">
          <p class="movement__subtitle">Concepto</p>
          <qr-input
            id="concept"
            [config]="inputConcept"
            (valueChange)="inputChangeConcept($event)"
            (blurChange)="inputTouched('concept')"
            [hasError]="hasErrorInput('concept')"
          ></qr-input>
        </div>
      </div>
      <!-- DESCRIPCIÓN -->
      <div class="movement__item movement__item--description">
        <div class="movement__description">
          <p class="movement__subtitle">Descripción</p>
          <qr-textarea
            id="description"
            class="text-area"
            (valueChange)="textareaChange($event)"
            (blurChange)="inputTouched('description')"
            [hasError]="hasErrorInput('description')"
          ></qr-textarea>
        </div>
      </div>
      <!-- DESTINO - DESTINO DEL INGRESO - ORIGEN DEL EGRESO -->
      <div class="movement__item">
        <div class="movement__destiny">
          <p class="movement__subtitle" *ngIf="!isExpense">
            Destino del ingreso
          </p>
          <p class="movement__subtitle" *ngIf="isExpense">Origen del egreso</p>

          <qr-dropdown
            id="paymentType"
            [config]="dropdownPayment"
            [selected]="movementForm.value.paymentType"
            (change)="selectPaymentType($event)"
            (blurChange)="inputTouched('paymentType')"
            [hasError]="hasErrorInput('paymentType')"
          ></qr-dropdown>
        </div>
        <!-- DESTINO - FECHA DE COBRO (SOLO PARA CHEQUES)-->
        <div class="movement__billing" *ngIf="isCheckPayment">
          <p class="movement__subtitle">Fecha de cobro</p>
          <qr-date-picker
            id="depositDate"
            [config]="datePickerDepositDate"
            (datepickerChange)="addDepositDate($event)"
            (blurChange)="inputTouched('depositDate')"
            [hasError]="hasErrorInput('depositDate')"
          ></qr-date-picker>
        </div>
      </div>
      <!-- TIPO DE COMPROBANTE -->
      <div class="movement__item">
        <div class="movement__destiny">
          <p class="movement__subtitle">Tipo de comprobante</p>
          <qr-dropdown
            id="voucherType"
            [config]="dropdownVoucherType"
            (change)="selectVoucherType($event)"
            (blurChange)="inputTouched('voucherType')"
            [hasError]="hasErrorInput('voucherType')"
          ></qr-dropdown>
        </div>
        <div class="movement__billing" *ngIf="isExpense">
          <p class="movement__subtitle">Número de factura</p>
          <qr-input
            [config]="inputInvoiceNumber"
            (valueChange)="changeInvoiceNumber($event)"
          ></qr-input>
        </div>
      </div>
      <!-- MONEDA - SUBTOTAL -TIPO DE CAMBIO -->
      <div class="movement__item">
        <div class="movement__money">
          <p class="movement__subtitle">Moneda</p>
          <qr-toggle
            [config]="toggleCurrency"
            (change)="changeCurrency($event)"
          ></qr-toggle>
        </div>
        <div class="movement__money movement__money--margin">
          <p class="movement__subtitle">Subtotal</p>
          <qr-input
            id="subTotal"
            [config]="inputSubtotal"
            (keydown)="isValidDecimalNumber($event)"
            (valueChange)="changeSubtotal($event)"
            (blurChange)="inputTouched('subTotal')"
            [hasError]="hasErrorInput('subTotal')"
          ></qr-input>
        </div>
        <div class="movement__money movement__money--margin">
          <p class="movement__subtitle">Tipo de cambio</p>
          <qr-input
            [config]="inputTc"
            (keydown)="isValidDecimalNumber($event)"
            [value]="typeChange"
            [isDisabled]="NODE === NODE_EC"
            (valueChange)="changeExchangeRate($event)"
            (blurChange)="inputTouched('exchangeRate')"
            [hasError]="hasErrorInput('exchangeRate')"
          ></qr-input>
        </div>
      </div>
      <!-- IVA -->
      <div class="movement__item movement__item--iva">
        <div class="movement__iva" *ngIf="!hideTaxFieldsForSc">
          <p class="movement__subtitle movement__subtitle--others">
            {{NODE === NODE_DO ? 'ITBIS' : 'IVA'}}</p>
          <qr-input
            [config]="inputIva"
            (keydown)="isValidDecimalNumber($event)"
            (valueChange)="changeIvaAmount($event)"
          ></qr-input>
        </div>
        <div
          class="movement__perception"
          *ngIf="showExpenseIibbAndOthersFields() && !hideTaxFieldsForSc"
        >
          <p class="movement__subtitle movement__subtitle--others">
           Percep. IIBB
          </p>
          <qr-input
            [config]="inputPerception"
            (keydown)="isValidDecimalNumber($event)"
            (valueChange)="addPerception($event)"
          ></qr-input>
        </div>
        <div
          class="movement__perception"
          [class.movement__perception--no-margin]="hideTaxFieldsForSc"
          *ngIf="showExpenseIibbAndOthersFields()"
        >
          <p class="movement__subtitle movement__subtitle--others">Otros</p>
          <qr-input
            [config]="inputOthers"
            (keydown)="isValidDecimalNumber($event)"
            (valueChange)="addOthers($event)"
          ></qr-input>
        </div>
      </div>
      <!-- TOTAL -->
      <div class="movement__item-total">
        <div class="movement__total">
          <p>Total</p>
          <p>{{ signalCurrency }} {{ getTotal() | number : "1.0-2" }}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="movement__footer">
    <qr-button [config]="buttonCloseOverlay" (click)="close.emit()"></qr-button>

    <qr-button
      [config]="buttonAddMovement"
      [isLoading]="isLoading"
      [isSubmitReady]="isSubmitReady"
      (click)="addMovement()"
    ></qr-button>
  </div>
</div>
